module.exports = __webpack_public_path__ + "img/lg_ring_g_o_null_1.12058cee.png";